{
  "noMoreToday": "Дальше по этим суткам записи нет.",
  "notYet": "Это время ещё не наступило — записи за него пока нет.",
  "jumpedTo": "В выбранном месте записи нет — открыли ближайшую, с {{at}}.",
  "fragmentSaved": "Фрагмент сохранён: {{file}}",
  "exportFailed": "Выгрузка не удалась.",
  "exportFailedStatus": "Выгрузка не удалась ({{status}}).",
  "notConfigured": "архив не настроен",
  "fromCache": "из кэша",
  "viaAgent": "через агента",
  "pickCamera": "Выберите камеру",
  "pickCameraHint": "Слева — камеры организации. Архив есть не у каждой: он зависит от того, пишет ли камера на свой диск или на регистратор.",
  "unavailable": "Архив недоступен",
  "pickMoment": "Выберите момент на шкале",
  "pickMomentHint": "Зелёным отмечено то, что записано. Щелчок по шкале — смотреть с этого момента.",
  "pickMomentBlind": "Этот способ доступа к архиву не знает, где есть запись: щёлкните по шкале наугад — если записи там нет, камера об этом скажет.",
  "opening": "Открываем запись… {{seconds}} с",
  "openingHint": "Камера ищет нужный момент на диске. Это дольше, чем открыть живой поток.",
  "notOpened": "Запись не открылась",
  "askingCamera": "спрашиваем камеру",
  "recordedToday": "записано {{duration}} за сутки",
  "scheduleUnknown": "расписание записи неизвестно",
  "selectToExport": "выделите фрагмент на шкале, чтобы выгрузить его файлом",
  "exportLimit": "Не длиннее {{minutes}} минут за раз",
  "exportUnsupported": "Выбранный способ доступа к архиву не умеет отдавать фрагмент файлом",
  "exporting": "Выгружаем…",
  "exportFragment": "Выгрузить фрагмент",
  "noCameras": "Камер пока нет. Заведите их в панели узла типа «камера» на карте сети.",
  "blankPicture": "Запись открылась, но ни одного кадра камера пока не отдала. Чаще всего это кодек: архив пишется основным потоком, и если он в H.265, браузер его не покажет (на Windows помогает расширение «HEVC Video Extensions» из Microsoft Store, в Safari 17+ работает сразу). Реже — камера ещё ищет момент на диске: тогда картинка появится сама.",
  "h265Refusal": "Основной поток камеры — H.265, а этот браузер его не декодирует. Архив пишется именно основным потоком, поэтому substream здесь не выручит, и уже записанное останется в H.265, даже если переключить камеру на H.264 (на будущее это всё равно стоит сделать). Чтобы посмотреть записанное сейчас: на Windows поставьте из Microsoft Store расширение «HEVC Video Extensions» — после этого H.265 играет и в Edge, и в Chrome; в Safari 17+ он играет сразу.",
  "undecodable": "Браузер не декодирует видео этой записи.",
  "describeRefusal": "Камера не отдала запись за это время. Обычно это значит, что записи за него нет, что канал или способ доступа к архиву в настройках камеры указан неверно, или что камера уже занята другим поиском по диску. Попробуйте соседний участок шкалы, а если не поможет — проверьте настройки архива камеры.",
  "authRefusal": "Камера не приняла учётные данные для архива. Проверьте логин и пароль у узла камеры — для записи они те же, что и для живого потока.",
  "startTimeout": "Запись не пошла за отведённое время. Возможно, за этот момент архива уже нет или камера занята другим поиском по диску — попробуйте соседний участок шкалы.",
  "openFailed": "Запись не удалось открыть.",
  "provider": {
    "hikvisionIsapi": "Hikvision ISAPI",
    "dahuaCgi": "Dahua CGI",
    "rtspReplay": "RTSP-повтор (ONVIF Profile G)"
  },
  "request": {
    "dahuaNextChunk": "очередной порции записей",
    "dahuaCreateSearch": "создания поиска по архиву",
    "dahuaFindByRange": "поиска записей по интервалу",
    "isapiRecordList": "списка записей ISAPI"
  },
  "duration": {
    "hoursMinutes": "{{hours}} ч {{minutes}} мин",
    "minutesSeconds": "{{minutes}} мин {{seconds}} с",
    "seconds": "{{seconds}} с"
  },
  "timeline": {
    "label": "Шкала архива",
    "hint": "щелчок — смотреть с этого момента, протяжка — выделить фрагмент, колесо — масштаб",
    "notPlaying": "воспроизведение не идёт",
    "unavailable": "шкала недоступна"
  },
  "zoom": {
    "title": "Масштаб шкалы",
    "back": "Сдвинуть окно назад",
    "forward": "Сдвинуть окно вперёд",
    "in": "Приблизить",
    "out": "Отдалить",
    "wholeDay": "Показать сутки целиком",
    "day": "сутки"
  },
  "controls": {
    "label": "Управление записью",
    "previous": "К предыдущему фрагменту",
    "previousTitle": "К предыдущему фрагменту записи",
    "next": "К следующему фрагменту",
    "nextTitle": "К следующему фрагменту записи",
    "back": "Назад на {{seconds}} секунд",
    "backShort": "Назад на {{seconds}} с",
    "forward": "Вперёд на {{seconds}} секунд",
    "forwardShort": "Вперёд на {{seconds}} с",
    "play": "Смотреть",
    "pause": "Пауза",
    "stop": "Остановить",
    "stopTitle": "Остановить показ и отпустить камеру",
    "noAudio": "запись без звука",
    "noAudioHint": "Камера не писала звук: микрофон выключен в её настройках или его нет",
    "speed": "Скорость",
    "speedAria": "Скорость воспроизведения",
    "onCamera": "на камере",
    "inBrowser": "в браузере"
  },
  "settings": {
    "notConfigured": "не настроен — записи не видно",
    "intro": "Архив запрашивается у самой камеры её же способом. Логин и пароль берутся те же, что и для потока, — привязанные к узлу учётные данные RTSP.",
    "httpPort": "Порт HTTP",
    "schemeAria": "Протокол веб-интерфейса камеры",
    "portHint": "веб-интерфейс, не RTSP — у части камер он не 80",
    "track": "Дорожка",
    "trackHint": "101 — основной поток первого канала, 102 — его substream",
    "channel": "Канал",
    "channelHint": "1 — сама камера; у регистратора номер канала",
    "template": "Шаблон",
    "templateHint": "Путь архивного потока камеры. Подстановки: {from}, {to}, {channel}, {track}, {path} — путь живого потока.",
    "timeFormat": "Формат",
    "epochSeconds": "секунды эпохи",
    "cameraClock": "Часы камеры",
    "clockHint": "минут от UTC. Ошибка здесь даёт пустой архив за нужные сутки и полный за соседние.",
    "none": "нет",
    "speedHint": "имя параметра скорости в адресе потока, если камера его принимает. Пусто — ускорять будет браузер.",
    "save": "Сохранить настройки архива"
  },
  "noArchive": "без архива",
  "reason": {
    "noProvider": "Для камеры «{{name}}» не выбран способ доступа к архиву. Откройте настройки камеры и укажите его — Hikvision, Dahua или RTSP-повтор.",
    "noAddress": "У узла «{{name}}» не указан адрес — идти за архивом некуда.",
    "agentOffline": "Агент площадки «{{name}}» не подключён, а камера доступна только через него. Проверьте службу netdeck-agent.",
    "unavailable": "Архив камеры «{{name}}» недоступен."
  },
  "warning": {
    "noSpeed": "Камера не принимает скорость воспроизведения в адресе потока — запись идёт в реальном времени.",
    "tooManyFiles": "Камера вернула больше {{limit}} файлов за этот интервал — показано начало. Возьмите интервал поуже, чтобы увидеть остальное.",
    "tooManyFragments": "Камера вернула больше {{limit}} фрагментов за этот интервал — показано начало. Возьмите интервал поуже, чтобы увидеть остальное.",
    "noTimeline": "Этот способ доступа к архиву не умеет сообщать, где есть запись: выберите интервал вручную. Если камера Hikvision или Dahua — укажите её способ доступа в настройках камеры, там таймлайн работает."
  },
  "cameraTimeout": "Камера не ответила за {{seconds}} с",
  "day": "Сутки"
}
